import type { TranslationTree } from '../../types';

export const signals: TranslationTree = {
  signals: {
    nav: 'Signale',
    page: {
      breadcrumb: 'Signalvisualisierung',
      title: 'Signalvisualisierung',
      description:
        'Rohsignale aus InfluxDB für jede Maschine über einen frei wählbaren Zeitraum abrufen und erkunden — ohne Vorhersage.',
    },
    source: {
      label: 'Signalquelle',
      tags: {
        active: 'aktiv',
        activeAt: 'aktiv · {{time}}',
        historyOnly: 'nur Verlauf',
        notFound: 'nicht in der Datenbank',
        linkedTo: 'verknüpft mit {{machine}}',
        noSource: 'keine Quelle',
      },
    },
    panel: {
      badge: 'Kontext',
      machineLabel: 'Maschine',
      machinePlaceholder: 'Maschine auswählen',
      unlinkedSources: 'Quellen ohne Maschine (Admins)',
      noSignalSource:
        'Diese Maschine hat keine Signalquelle, daher gibt es nichts anzuzeigen. Verknüpfen Sie eine unter Werkstatt → Maschinen.',
      machineStatus: {
        lastActivity: 'Letzte Aktivität: {{date}}',
        noData: 'Keine Daten für diese Maschine',
      },
      signalsLabel: 'Signale',
      signalsCounter: '{{count}} / {{max}} ausgewählt',
      signalsEmptyMachine: 'Wählen Sie eine Maschine, um die verfügbaren Signale zu sehen',
      signalsLoading: 'Signale werden geladen…',
      groups: {
        spindle: 'Spindel',
        x: 'Achse X',
        y: 'Achse Y',
        z: 'Achse Z',
        b: 'Achse B',
        c: 'Achse C',
        lubrication: 'Schmierung',
        other: 'Sonstige',
      },
      timeRangeLabel: 'Zeitraum',
      chips: {
        '15m': '15 Min',
        '1h': '1 Std',
        '8h': '8 Std',
        '24h': '24 Std',
        '7d': '7 Tg',
        custom: 'Benutzerdefiniert',
      },
      customStartLabel: 'Start',
      customEndLabel: 'Ende',
      lastActivityShortcut: 'Letzte Aktivität (1 Std)',
      rangeError: {
        invalid: 'Ungültige Daten.',
        order: 'Das Enddatum muss nach dem Startdatum liegen.',
        tooLong: 'Der Zeitraum darf 90 Tage nicht überschreiten.',
      },
      toolIdLabel: 'Werkzeug (optional)',
      toolIdPlaceholder: 'Werkzeug-ID',
      loadButton: 'Signale laden',
    },
    tags: {
      spindlePwr: 'Spindelleistung',
      xFollErr: 'Schleppfehler X',
      yFollErr: 'Schleppfehler Y',
      zFollErr: 'Schleppfehler Z',
    },
    chart: {
      badge: 'Signale',
      helper: '{{visible}} von {{total}} Kanälen · {{samples}} Samples · {{passes}} Durchgänge',
      helperAggregated: '{{visible}} von {{total}} Kanälen · {{window}} ms Fenster · {{samples}} Pkt.',
      viewStack: 'Gestapelt',
      viewOverlay: 'Überlagert',
      viewLabel: 'Diagrammanordnung',
      peak: 'Spitze {{value}}',
      timeAxisLabel: 'Zeit (s)',
      chipsGroupLabel: 'Kanalsichtbarkeit umschalten',
      passLabel: 'Durchgang {{passIndex}}',
      errorTitle: 'Signal nicht verfügbar',
      errorRetry: 'Erneut versuchen',
      emptyWindowTitle: 'Keine Daten in diesem Zeitraum',
      emptyWindowHint:
        'Diese Maschine hat im gewählten Zeitraum keine Signale. Verwenden Sie die Verknüpfung „Letzte Aktivität" im Panel, um zu den aktuellsten Daten zu springen.',
    },
    empty: {
      title: 'Maschine wählen und Signale laden',
      description: 'Wählen Sie eine Maschine und einen Zeitraum und klicken Sie dann auf Signale laden.',
    },
  },
};
